<main class="adr-component" [class.shake-horizontal]="confirmDelete">
  <div
    class="adr-container-confirm-delete"
    [class.adr-notPreparedToDelete]="!prepareDelete"
    [class.adr-preparedToDelete]="prepareDelete"
    (click)="deleteAddress(dataAddress)"
  >
    <lbca-icon name="lucide:trash-2" />
  </div>
  <div class="adr-fields-container" [class.pl-16]="prepareDelete" [class.pl-4]="!prepareDelete">
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-4">
        <lbca-input-text
          [label]="fields.cep.label"
          [labeled]="isLabeled"
          [error]="dataErrors.cep"
          [maskInput]="'CEP'"
          (changeValue)="setValue('cep', $event)"
          [require]="isRequired && fields.cep.require"
          [value]="dataAddress.cep"
        ></lbca-input-text>
      </div>
      <div class="col-span-8">
        <lbca-input-text
          [label]="fields.street.label"
          [labeled]="isLabeled"
          [error]="dataErrors.street"
          (changeValue)="setValue('street', $event)"
          [require]="isRequired && fields.street.require"
          [value]="dataAddress.street"
        ></lbca-input-text>
      </div>
      <div class="col-span-4">
        <lbca-input-text
          [label]="fields.neighborhood.label"
          [labeled]="isLabeled"
          [error]="dataErrors.neighborhood"
          (changeValue)="setValue('neighborhood', $event)"
          [require]="isRequired && fields.neighborhood.require"
          [value]="dataAddress.neighborhood"
        ></lbca-input-text>
      </div>
      <div class="col-span-3">
        <lbca-input-text
          [label]="fields.city.label"
          [labeled]="isLabeled"
          [error]="dataErrors.city"
          (changeValue)="setValue('city', $event)"
          [require]="isRequired && fields.city.require"
          [value]="dataAddress.city"
        ></lbca-input-text>
      </div>
      <div class="col-span-3">
        <lbca-input-text
          [label]="fields.state.label"
          [labeled]="isLabeled"
          [error]="dataErrors.state"
          (changeValue)="setValue('state', $event)"
          [require]="isRequired && fields.state.require"
          [value]="dataAddress.state"
        ></lbca-input-text>
      </div>
      <div class="col-span-2">
        <lbca-input-text
          [label]="fields.number.label"
          [labeled]="isLabeled"
          [error]="dataErrors.number"
          (changeValue)="setValue('number', $event)"
          [require]="isRequired && fields.number.require"
          [value]="dataAddress.number"
        ></lbca-input-text>
      </div>

      @if (!displayFields || displayFields['type']) {
        <div class="col-span-4">
          @if (isLabeled) {
            <lbca-input-radio
              [label]="fields.type.label"
              [error]="dataErrors.type"
              (changeValue)="setValue('type', $event)"
              [require]="isRequired && fields.type.require"
              [options]="fields.type.options"
              [inline]="true"
              [value]="dataAddress.type"
            ></lbca-input-radio>
          }
          @if (!isLabeled) {
            <lbca-select
              [label]="fields.type.label"
              [error]="dataErrors.type"
              [labeled]="false"
              (changeValue)="setValue('type', $event)"
              [require]="isRequired && fields.type.require"
              [options]="fields.type.options"
              [value]="dataAddress.type"
            ></lbca-select>
          }
        </div>
      }

      <div class="col-span-4">
        <lbca-input-text
          [label]="fields.complement.label"
          [labeled]="isLabeled"
          [error]="dataErrors.complement"
          (changeValue)="setValue('complement', $event)"
          [require]="isRequired && fields.complement.require"
          [value]="dataAddress.complement"
        ></lbca-input-text>
      </div>

      <div class="col-span-4">
        @if (isLabeled) {
          <div class="adr-button-delete-container">
            @if (!prepareDelete) {
              <lbca-button
                (click)="prepareDeleteAddress()"
                variant="unstyled"
                size="small"
                icon
                title="Excluir"
              >
                <lbca-icon name="lucide:trash-2" />
              </lbca-button>
            }
            @if (prepareDelete) {
              <lbca-button
                (click)="prepareDeleteAddress()"
                size="small"
                variant="unstyled"
                color="error"
                icon
                title="Fechar"
              >
                <lbca-icon name="lucide:x" />
              </lbca-button>
            }
          </div>
        }
      </div>
    </div>
  </div>
</main>
